import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyService } from '../services';

@Pipe({ name: 'formatCurrency', pure: true, standalone: true })
export class FormatCurrencyPipe implements PipeTransform {
    constructor(private currencyService: CurrencyService) {}

    transform(
        value: number | string | null | undefined,
        currencyCode?: string,
        display: 'code' | 'symbol' | 'symbol-narrow' | string = 'symbol',
        digitsInfo?: string,
        locale?: string
    ): string {
        return this.currencyService.format(value, currencyCode, display, digitsInfo, locale);
    }
}
